// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"332":"f360ad32","354":"37bbd69d","838":"023f83a9"}[chunkId] + ".js";
};